export default function ConfirmDetails({ checked, onChange, kind = "invoice" }) {
  return (
    <label className="flex items-start gap-3 min-h-[44px] py-2 px-3 rounded-lg border border-gold/40 bg-gold/5 cursor-pointer" data-testid="confirm-details-label">
      <input type="checkbox" checked={checked} onChange={(e) => onChange(e.target.checked)}
        className="mt-0.5 w-5 h-5 accent-gold shrink-0" data-testid="confirm-details-checkbox" />
      <span className="text-sm text-navy">
        I have checked every detail against the original {kind}{kind === "Z report" ? "" : ", including anything filled in by AI"}.
      </span>
    </label>
  );
}
